/* eslint-disable default-param-last */
import axios from 'axios';
import apiBaseUrl from '../../config/apiBaseUrl';
import { processApiResponse } from '../helper/processApiResponse';
export const orderAPI = {
    ParamVerifyV6(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/v6/client/order/param/verify`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    TimeSlotFeeCalculate(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/timeSlot/fee/calculate`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    InitV9(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/v9/client/order/init`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    FeedbackPostV2(params = {
        _id: '',
        careOrderId: '',
        score: null,
        comment: '',
        remarkList: [],
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/v2/client/order/feedback/post`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    MakeOfferAccept(params = {
        _id: '',
        careOrderId: '',
        makeOfferId: '',
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/makeOffer/accept`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    MakeOfferCancelV2(params = {
        _id: '',
        careOrderId: '',
        makeOfferId: '',
        cancellationRemark: '',
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/v2/client/order/makeOffer/cancel`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    CancelationFeeCalculate(params = {
        _id: '',
        careOrderId: '',
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/cancellationFee/calculate`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    TimeSlotUpdate(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/timeSlot/update`;
        return processApiResponse(axios.patch(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    TimeSlotInit(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/timeSlot/init`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    TimeSlotDelete(params = {
        _id: '',
        timeSlotId: '',
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/timeSlot/delete`;
        return processApiResponse(axios.delete(apiRoute, { ...config, data: params }), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    Cancel(params = {
        _id: '',
        careOrderId: '',
        doChargeCancellationFee: true,
        cancellationRemark: '',
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/v3/client/order/cancel`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    End(params = {
        _id: '',
        careOrderId: '',
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/end`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    MakeOfferLike(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/makeOffer/like`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    MakeOfferUnlike(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/makeOffer/unlike`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    ServiceCanCareClientInitCareOrderGet(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/order/service/canCareClientInitCareOrder/get`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
};
